import {JsonHttpClient} from '../JsonHttpClient';

const baseUrl = process.env.REACT_APP_API_URL;
export const M2HttpClient = new JsonHttpClient({baseUrl});
